import { styled } from '@mui/system';

export const TasksWrapper = styled('div')({
	marginBottom: '25px',
});
